import { render, staticRenderFns } from "./FactoryDialog.vue?vue&type=template&id=2ca61aaf&scoped=true&"
import script from "./FactoryDialog.vue?vue&type=script&lang=js&"
export * from "./FactoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./FactoryDialog.vue?vue&type=style&index=0&id=2ca61aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca61aaf",
  null
  
)

export default component.exports